import { ADDRESS_TYPE } from '@/api/type/commonTypes';
import React, { useCallback, useState } from 'react';
import ProfileInput from '../../component/ProfileInput';
import { GetPartnerBusinessProfileResponse } from '@/api/type/types';
import { useDispatch } from 'react-redux';
import { businessProfile } from '@/stores/slices/business-profile/businessProfileSlice';
import styled from 'styled-components';
import { useAppSelector } from '@/stores/hooks';

interface BusinessAddressProps {
  isEdit: boolean;
  profile: GetPartnerBusinessProfileResponse;
}
const BusinessAddress = ({ isEdit, profile }: BusinessAddressProps) => {
  const putProfile = useAppSelector(
    (state) => state.businessProfile.putBusinessProfile
  );

  const addressValue =
    isEdit && putProfile?.partnerAddress
      ? putProfile.partnerAddress
      : profile.partnerAddress;
  const dispatch = useDispatch();

  const updateAddress = useCallback(
    (partial: Partial<ADDRESS_TYPE>) => {
      dispatch(
        businessProfile.putBusinessProfile({
          partnerAddress: {
            ...addressValue,
            ...partial,
          },
        })
      );
    },
    [addressValue, dispatch]
  );

  const onChangeZipCode = useCallback(
    (e: React.ChangeEvent<HTMLInputElement>) => {
      const onlyNumbers = e.target.value.replace(/\D/g, '');
      updateAddress({ postalCode: onlyNumbers });
    },
    [updateAddress]
  );

  const onChangeAddress1 = useCallback(
    (e: React.ChangeEvent<HTMLInputElement>) => {
      updateAddress({ address1: e.target.value });
    },
    [updateAddress]
  );

  const onChangeAddress2 = useCallback(
    (e: React.ChangeEvent<HTMLInputElement>) => {
      updateAddress({ address2: e.target.value });
    },
    [updateAddress]
  );

  const onChangeCity = useCallback(
    (e: React.ChangeEvent<HTMLInputElement>) => {
      updateAddress({ city: e.target.value });
    },
    [updateAddress]
  );

  const onChangeState = useCallback(
    (e: React.ChangeEvent<HTMLInputElement>) => {
      updateAddress({ state: e.target.value });
    },
    [updateAddress]
  );

  console.log('addressValue', addressValue);

  return (
    <Container>
      {profile.countryCode === 'KR' && (
        <AddressSection data-edit={isEdit}>
          <ProfileInput
            isEdit={isEdit}
            value={addressValue.postalCode}
            type="tel"
            onChange={onChangeZipCode}
            inputId="postalCode"
            inputName="postalCode"
            inputAriaLabel="postal code"
            height="35px"
            width="419px"
          />
          <ProfileInput
            isEdit={isEdit}
            value={addressValue.address1}
            onChange={onChangeAddress1}
            inputId="address1"
            inputName="address1"
            inputAriaLabel="address line 1"
            height="35px"
            width="604px"
          />
          <ProfileInput
            isEdit={isEdit}
            value={addressValue.address2}
            onChange={onChangeAddress2}
            inputId="address2"
            inputName="address2"
            inputAriaLabel="address line 2"
            height="35px"
            width="604px"
          />
        </AddressSection>
      )}
      {profile.countryCode !== 'KR' && (
        <AddressSection data-edit={isEdit}>
          <ProfileInput
            isEdit={isEdit}
            value={addressValue.address1}
            onChange={onChangeAddress1}
            inputId="address1"
            inputName="address1"
            inputAriaLabel="address line 1"
            height="35px"
            width="419px"
          />
          <ProfileInput
            isEdit={isEdit}
            value={addressValue.address2}
            onChange={onChangeAddress2}
            inputId="address2"
            inputName="address2"
            inputAriaLabel="address line 2"
            height="35px"
            width="604px"
          />
          <ProfileInput
            isEdit={isEdit}
            value={addressValue.city ?? ''}
            onChange={onChangeCity}
            inputId="addressCity"
            inputName="addressCity"
            inputAriaLabel="address city"
            height="35px"
            width="604px"
          />
          <ProfileInput
            isEdit={isEdit}
            value={addressValue.state ?? ''}
            onChange={onChangeState}
            inputId="addressState"
            inputName="addressState"
            inputAriaLabel="address state"
            height="35px"
            width="713px"
          />
          <ProfileInput
            isEdit={isEdit}
            value={addressValue.postalCode}
            onChange={onChangeZipCode}
            inputId="postalCode"
            inputName="postalCode"
            inputAriaLabel="postal code"
            height="35px"
            width="713px"
          />
        </AddressSection>
      )}
    </Container>
  );
};

export default BusinessAddress;

const Container = styled.div`
  flex: 1;
`;

const AddressSection = styled.div`
  display: flex;
  flex-direction: column;
  gap: 21px;
  width: 100%;
  &[data-edit='true'] {
    gap: 7px;
  }
`;
